export const BASE_PATH = '/combo-application'

export enum PathType {
    CREATE = 'comboApplicationCreate',
    SUMMARY = 'comboApplicationSummary'
}
